import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IGetDeclarationOrderIdsRepoResponse = IRepoResponse<200, string[]> | IRepoResponse<400 | 500, string>;
export type IGetDeclarationOrderIdsRepoInput = { id?: number | string };

export type IGetDeclarationOrderIdsRepo = IRepo<[IGetDeclarationOrderIdsRepoInput], IGetDeclarationOrderIdsRepoResponse>;

export const GetDeclarationOrderUrlRepoType = Symbol.for('GetDeclarationOrderIdsRepo');

@bind(GetDeclarationOrderUrlRepoType)
export class GetDeclarationOrderIdsRepo implements IGetDeclarationOrderIdsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ id }) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/declaration/orders', { declaration_id: id }) });

      if (result.status === 200) {
        const data: string[] = result.data.data;

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
